import script from "./multipleChoice.vue?vue&type=script&setup=true&lang=js"
export * from "./multipleChoice.vue?vue&type=script&setup=true&lang=js"

import "./multipleChoice.vue?vue&type=style&index=0&id=05d05511&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\learning-center\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d05511"]])

export default __exports__